if (!customElements.get('gift-card-form')) {
  customElements.define('gift-card-form', class GiftCardForm extends HTMLElement {

    connectedCallback() {
      this.form         = this.querySelector('form');
      this.variantInput = this.querySelector('#gift-card-variant-id');
      this.variantBtns  = this.querySelectorAll('.gift-card-variant-btn');
      this.toInput      = this.querySelector('#gc-to');
      this.fromInput    = this.querySelector('#gc-from');
      this.emailInput   = this.querySelector('#gc-email');
      this.emailConfirm = this.querySelector('#gc-email-confirm');
      this.emailProp    = this.querySelector('#gc-email-prop');
      this.submitBtn    = this.querySelector('#gc-submit');
      this.daySelect    = this.querySelector('#gc-day');
      this.monthSelect  = this.querySelector('#gc-month');
      this.yearSelect   = this.querySelector('#gc-year');
      this.dateHidden   = this.querySelector('#gc-delivery-date');
      this.previewTo    = this.querySelector('#gc-preview-to');
      this.previewFrom  = this.querySelector('#gc-preview-from');
      this.previewPrice = this.querySelector('#gc-preview-price');

      this.cart = document.querySelector('cart-drawer');

      this.variantBtns.forEach((btn) => {
        btn.addEventListener('click', this.onVariantSelect.bind(this, btn));
      });

      this.toInput.addEventListener('input',  () => this.updatePreview());
      this.fromInput.addEventListener('input', () => this.updatePreview());
      this.updatePreview();

      [this.daySelect, this.monthSelect, this.yearSelect].forEach((el) => {
        el.addEventListener('change', () => this.updateDate());
      });
      this.updateDate();

      this.form.addEventListener('submit', this.onSubmit.bind(this));
    }

    onVariantSelect(btn) {
      this.variantBtns.forEach((b) => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      this.variantInput.value = btn.dataset.variantId;
      this.previewPrice.textContent = btn.dataset.variantPrice;
    }

    updatePreview() {
      this.previewTo.textContent   = 'To: '   + (this.toInput.value   || '—');
      this.previewFrom.textContent = 'From: ' + (this.fromInput.value || '—');
    }

    updateDate() {
      const months = ['January','February','March','April','May','June','July','August','September','October','November','December'];
      const mm = String(months.indexOf(this.monthSelect.value) + 1).padStart(2, '0');
      const dd = String(this.daySelect.value).padStart(2, '0');
      this.dateHidden.value = `${this.yearSelect.value}-${mm}-${dd}`;
    }

    validate() {
      let valid = true;

      [this.toInput, this.fromInput].forEach((input) => {
        const empty = !input.value.trim();
        input.style.borderColor = empty ? '#c00' : '';
        if (empty) valid = false;
      });

      const emailErr = this.querySelector('#gc-email-error');
      const emailOk  = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.emailInput.value);
      emailErr.classList.toggle('gift-card-form__error--visible', !emailOk);
      this.emailInput.style.borderColor = emailOk ? '' : '#c00';
      if (!emailOk) valid = false;

      const confirmErr = this.querySelector('#gc-email-confirm-error');
      const match      = this.emailInput.value === this.emailConfirm.value;
      confirmErr.classList.toggle('gift-card-form__error--visible', !match);
      this.emailConfirm.style.borderColor = match ? '' : '#c00';
      if (!match) valid = false;

      return valid;
    }

    onSubmit(e) {
      e.preventDefault();
      if (!this.validate()) return;

      this.emailProp.value = this.emailInput.value;

      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((s) => s.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

      config.body = formData;

      fetch(routes.cart_add_url, config)
        .then((res) => res.json())
        .then((response) => {
          if (response.status) {
            this.submitBtn.removeAttribute('aria-disabled');
            this.submitBtn.classList.remove('loading');
            alert(response.description || 'Something went wrong. Please try again.');
            return;
          }

          if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'gift-card-form',
            productVariantId: formData.get('id'),
            cartData: response,
          });

          this.cart.renderContents(response);
        })
        .catch(() => {
          this.submitBtn.removeAttribute('aria-disabled');
          this.submitBtn.classList.remove('loading');
          alert('Something went wrong. Please try again.');
        })
        .finally(() => {
          if (this.cart?.classList.contains('is-empty')) {
            this.cart.classList.remove('is-empty');
          }
          setTimeout(() => {
            this.submitBtn.removeAttribute('aria-disabled');
            this.submitBtn.classList.remove('loading');
          }, 200);
        });
    }
  });
}
